module.exports = __webpack_public_path__ + "media/images/indicators/seca-4aa96e442d8ecb8bea899f77035c52f9.png";